import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  "aria-hidden": "true",
  class: "mesh-backdrop"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "mesh-layer mesh-layer-a" }, null, -1),
    _createElementVNode("div", { class: "mesh-layer mesh-layer-b" }, null, -1),
    _createElementVNode("div", { class: "mesh-layer mesh-layer-c" }, null, -1)
  ]))]))
}